import React from "react";
import { useTranslation } from "react-i18next";
import { Link, Body2 } from "@activecollab/components";
import { DropboxPreviewIcon } from "~/components/svg";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const DropboxPreview = ({ url }) => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <DropboxPreviewIcon />
          <div className="ang_preview_message">
            <Body2
              className="tw-text-theme-600"
              align="center"
            >
              {t("To view this file, open it in Dropbox.")}
            </Body2>
            <Link
              href={url}
              className="btn btn--pro-2 view_in_dropbox"
              target="_blank"
              rel="noreferrer"
              variant="primary"
            >
              {t("View in Dropbox")}
            </Link>
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};

DropboxPreview.propTypes = mediaElementShape;
